import { render } from "./Purchases.vue?vue&type=template&id=1829265b&scoped=true"
import script from "./Purchases.vue?vue&type=script&lang=js"
export * from "./Purchases.vue?vue&type=script&lang=js"

import "./Purchases.vue?vue&type=style&index=0&id=1829265b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1829265b"]])

export default __exports__